<script setup>
import {useSettingsManager} from "../../Registration/stores/settingsManagerStore";

const {settings, limits, event} = useSettingsManager();
    const guestLimitEnabled = event?.settings?.limited_guests;
    let normalGuestLimitExceeded = false;
    let waitlistedGuestLimitExceeded = false;
    if(guestLimitEnabled) {
        const currentGuestCount = limits.current_guest_count_for_guest_limit
        const maxGuestCount = event?.settings?.limited_guests_max_number;
        const isWaitlistEnabled = event?.settings?.limited_guests_waitlisted;
        normalGuestLimitExceeded = currentGuestCount >= maxGuestCount;
        if(isWaitlistEnabled){
            const currentWaitlistedGuestCount = limits.current_guest_count_for_waitlist_limit;
            const maxWaitlistedGuestCount = event?.settings?.limited_guests_waitlisted_max_number
            // An empty waitlist maximum means unlimited (AIRLST-5285 B3), so the limit is never exceeded.
            waitlistedGuestLimitExceeded = maxWaitlistedGuestCount !== null && maxWaitlistedGuestCount !== undefined && currentWaitlistedGuestCount >= maxWaitlistedGuestCount;
        }
    }

</script>

<template>
    <div>
        <span v-if="normalGuestLimitExceeded && !waitlistedGuestLimitExceeded" class="registration-message-waitlist block" v-html="settings.messages.guestWaitListLimitReached">
        </span>
    </div>
</template>

<style scoped>

</style>
